import React from "react";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";
import FacebookIcon from "@material-ui/icons/Facebook";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import "../styles/Footer.css";
import logo4 from "../assets/logo4.png";

function Footer() {
  return (
    <div className="footer">
      <div className="footer-logo">
        <img src={logo4}></img>
      </div>
      <div class="footer-content">
        <p class="name">Kayton Froeschl</p>
        <p class="email">kfroeschl@gmail.com</p>
        <p class="phone">913.522.6698</p>
        <p>This website was created using: ReactJS, HTML, CSS</p>
      </div>
    </div>
  );
}

export default Footer;
